import { Pipe, PipeTransform } from '@angular/core';

import { CourseChoice } from '../services/application/application.service';

@Pipe({
    name: 'courseRequestStatus',
})
export class CourseRequestStatusPipe implements PipeTransform {
    transform(value: CourseChoice, formStatus: number) {
        if (!value) {
            return '';
        }

        if (value.ScheduledBy) {
            // It's been scheduled by a college advisor. Check to see if it was removed as well, which would only
            // happen if it was scheduled and then removed by the advisor as well.
            if (value.RemovedBy) {
                return 'Removed';
            } else {
                return 'Approved by college advisor';
            }
        }

        if (value.RemovedBy) {
            return 'Removed';
        }

        if (value.AddedBy) {
            // It has been added. If we have a form status, we'll try to be more informative. Otherwise, we'll
            // leave this blank rather than mislead people.
            if (formStatus != null) {
                switch (formStatus) {
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                        return 'Awaiting approval by school counselor';
                    case 4:
                        return 'Awaiting approval by school admin';
                    case 5:
                        return 'Awaiting approval by college advisor';
                    case 6:
                        return '';
                }
            }
        }

        return '';
    }
}



// WEBPACK FOOTER //
// ./src/pipes/courserequeststatus.pipe.ts